import React, { Component } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { Auth } from "../helpers/auth";
import { roleConstants } from "../constants";

import AdminDashboard from "./pages/dashboard/adminDashboard";
import PartnerDashboard from "./pages/partner-dashboard";
import PartnerListNew from "./pages/partner-list-new";
import PartnerPerformance from "./pages/partner-peformance";
import ProductList from "./pages/product-list";
import DevelopmentTimeline from "./pages/development-timeline";
import FilingPlans from "./pages/filing-plans";
import SalesReport from "./pages/sales-report";
import ChangePassword from "./pages/change-password";
import AddPartner from "./pages/add-partner";
import AddProduct from "./pages/add-product";
import PDTReport from "./pages/report-pdt";
import FilingPlansReport from "./pages/report-filing-plans";
import ConsolidatedSalesReport from "./pages/report-sales-report";
import UserProfilePage from "./pages/profile";
import AdminSettings from "./pages/admin-settings";
import PartnerCompliance from "./pages/partner-compliance";
import MOM from "./pages/MOM";
import ComplianceTemplate from "./pages/compliance-template";
import AddComplianceTemplate from "./pages/add-compliance-template";
import AssignComplianceTemplate from "./pages/assign-compliance-template";
import PartnerComplianceLetter from "./pages/partner-compliance-letter";
import InteractiveMap from "./pages/interactive-map";
import DataManagement from "./pages/data-management";
import Chats from "./pages/chats";
import PartnerRoyaltySalesApproval from "./pages/royalty-sales-approvals";
import RaiseApprovalRequest from "./pages/raise-approval-request";
import PartnerInvoice from "./pages/royalty-invoice-tracking";
import ViewRaisedRequest from "./pages/view-raised-request";
import AddInvoiceData from "./pages/add-invoice-data";
import ViewInvoiceInvoiceTracking from "./pages/view-invoice";
import AddPaymentProof from "./pages/add-payment-proof";
import AddTaxData from "./pages/add-tax-data";
import ViewTaxInvoiceTracking from "./pages/view-tax-data";
import ApprovalRequests from "./pages/approval-requests";

const AdminDashboardPage = Auth(AdminDashboard, [
  roleConstants.ADMIN,
  roleConstants.STAFF,
  roleConstants.PARTNER,
  roleConstants.DIAGNOSTIC_ADMIN,
  roleConstants.DIAGNOSTIC_REVIEWER,
]);
const ChatsPage = Auth(Chats, [
  roleConstants.ADMIN,
  roleConstants.STAFF,
  roleConstants.PARTNER,
]);
const PartnerDashboardPage = Auth(PartnerDashboard, [roleConstants.PARTNER]);
const ChangePasswordPage = Auth(ChangePassword, [
  roleConstants.ADMIN,
  roleConstants.STAFF,
  roleConstants.PARTNER,
  roleConstants.LEGAL,
  roleConstants.LICENSOR,
  roleConstants.DIAGNOSTIC_ADMIN,
  roleConstants.DIAGNOSTIC_REVIEWER,
]);
const AdminProfilePage = Auth(UserProfilePage, [
  roleConstants.ADMIN,
  roleConstants.STAFF,
  roleConstants.LEGAL,
  roleConstants.LICENSOR,
  roleConstants.DIAGNOSTIC_ADMIN,
  roleConstants.DIAGNOSTIC_REVIEWER,
]);
const PartnerProfilePage = Auth(UserProfilePage, [roleConstants.PARTNER]);
const PartnerListNewPage = Auth(PartnerListNew, [
  roleConstants.ADMIN,
  roleConstants.STAFF,
  roleConstants.DIAGNOSTIC_ADMIN,
  roleConstants.DIAGNOSTIC_REVIEWER,
]);
const AddPartnerPage = Auth(AddPartner, [roleConstants.ADMIN, roleConstants.DIAGNOSTIC_ADMIN]);
const PartnerPerformancePage = Auth(PartnerPerformance, [
  roleConstants.ADMIN,
  roleConstants.STAFF,
]);
const ProductListPage = Auth(ProductList, [
  roleConstants.ADMIN,
  roleConstants.STAFF,
  roleConstants.DIAGNOSTIC_ADMIN,
  roleConstants.DIAGNOSTIC_REVIEWER,
]);
const AddProductPage = Auth(AddProduct, [roleConstants.ADMIN, roleConstants.DIAGNOSTIC_ADMIN]);
const DevelopmentTimelinePage = Auth(DevelopmentTimeline, [
  roleConstants.PARTNER,
  roleConstants.ADMIN,
  roleConstants.STAFF,
  roleConstants.DIAGNOSTIC_ADMIN,
  roleConstants.DIAGNOSTIC_REVIEWER,
]);
const FilingPlansPage = Auth(FilingPlans, [
  roleConstants.PARTNER,
  roleConstants.ADMIN,
  roleConstants.STAFF,
  roleConstants.DIAGNOSTIC_ADMIN,
  roleConstants.DIAGNOSTIC_REVIEWER,
]);
const SalesReportPage = Auth(SalesReport, [
  roleConstants.PARTNER,
  roleConstants.ADMIN,
  roleConstants.STAFF,
  roleConstants.DIAGNOSTIC_ADMIN,
  roleConstants.DIAGNOSTIC_REVIEWER,
]);
const PDTReportPage = Auth(PDTReport, [
  roleConstants.ADMIN,
  roleConstants.STAFF,
  roleConstants.DIAGNOSTIC_ADMIN,
  roleConstants.DIAGNOSTIC_REVIEWER,
]);
const FilingPlansReportPage = Auth(FilingPlansReport, [
  roleConstants.ADMIN,
  roleConstants.STAFF,
  roleConstants.DIAGNOSTIC_ADMIN,
  roleConstants.DIAGNOSTIC_REVIEWER,
]);
const ConsolidatedSalesReportPage = Auth(ConsolidatedSalesReport, [
  roleConstants.ADMIN,
  roleConstants.STAFF,
  roleConstants.DIAGNOSTIC_ADMIN,
  roleConstants.DIAGNOSTIC_REVIEWER,
]);
const AdminSettingsPage = Auth(AdminSettings, [
  roleConstants.ADMIN,
  roleConstants.STAFF,
]);
const PartnerCompliancePage = Auth(PartnerCompliance, [
  roleConstants.ADMIN,
  roleConstants.STAFF,
  roleConstants.LEGAL,
]);
const PartnerRoyaltySalesApprovalPage = Auth(PartnerRoyaltySalesApproval, [
  roleConstants.PARTNER,
  roleConstants.STAFF,
  roleConstants.ADMIN,
  roleConstants.DIAGNOSTIC_ADMIN,
  roleConstants.DIAGNOSTIC_REVIEWER,
]);
const ViewRaisedRequestPage = Auth(ViewRaisedRequest, [
  roleConstants.ADMIN,
  roleConstants.PARTNER,
  roleConstants.STAFF,
]);
const RaiseApprovalRequestPage = Auth(RaiseApprovalRequest, [
  roleConstants.PARTNER,
]);
const MOMPage = Auth(MOM, [
  roleConstants.ADMIN,
  roleConstants.STAFF,
  roleConstants.LEGAL,
]);
const ComplianceTemplatePage = Auth(ComplianceTemplate, [
  roleConstants.ADMIN,
  roleConstants.STAFF,
  roleConstants.LEGAL,
]);
const AddComplianceTemplatePage = Auth(AddComplianceTemplate, [
  roleConstants.ADMIN,
  roleConstants.LEGAL,
]);
const AssignComplianceTemplatePage = Auth(AssignComplianceTemplate, [
  roleConstants.ADMIN,
  roleConstants.LEGAL,
]);
const PartnerComplianceLetterPage = Auth(PartnerComplianceLetter, [
  roleConstants.PARTNER,
  roleConstants.LEGAL,
]);
const InteractiveMapPage = Auth(InteractiveMap, [
  roleConstants.ADMIN,
  roleConstants.STAFF,
  roleConstants.LEGAL,
]);
const PartnerInvoicePage = Auth(PartnerInvoice, [
  roleConstants.ADMIN,
  roleConstants.PARTNER,
  roleConstants.LICENSOR,
  roleConstants.STAFF,
]);
const AddInvoiceDataPage = Auth(AddInvoiceData, [
  roleConstants.PARTNER,
  roleConstants.LICENSOR,
]);
const AddTaxDataPage = Auth(AddTaxData, [
  roleConstants.PARTNER,
  roleConstants.LICENSOR,
]);
const ViewInvoiceInvoiceTrackingPage = Auth(ViewInvoiceInvoiceTracking, [
  roleConstants.PARTNER,
  roleConstants.LICENSOR,
  roleConstants.ADMIN,
  roleConstants.STAFF,
]);
const ViewTaxInvoiceTrackingPage = Auth(ViewTaxInvoiceTracking, [
  roleConstants.PARTNER,
  roleConstants.LICENSOR,
  roleConstants.ADMIN,
  roleConstants.STAFF,
]);
const AddPaymentProofPage = Auth(AddPaymentProof, [
  roleConstants.PARTNER,
  roleConstants.LICENSOR,
  roleConstants.ADMIN,
]);
const ApprovalRequestsPage = Auth(ApprovalRequests, [
  roleConstants.ADMIN,
  roleConstants.PARTNER,
  roleConstants.LEGAL,
  roleConstants.LICENSOR,
]);

const NotFoundRedirect = () => <Navigate to="/error-404" replace />;

const App = () => {
  return (
    <div
      className="gx-main-content-wrapper gx-mb-2"
      style={{ paddingLeft: "26px", paddingRight: "26px" }}
    >
      <Routes>
        <Route path="change-password" element={<ChangePasswordPage />} />
        <Route path="admin/dashboard" element={<AdminDashboardPage />} />
        <Route path="admin/partner-list" element={<PartnerListNewPage />} />
        <Route path="admin/chats" element={<ChatsPage />} />
        <Route path="admin/edit-partner/:id" element={<AddPartnerPage />} />
        <Route path="admin/add-partner" element={<AddPartnerPage />} />
        <Route
          path="admin/partner-performance"
          element={<PartnerPerformancePage />}
        />
        <Route path="admin/product-list" element={<ProductListPage />} />
        <Route path="admin/add-product" element={<AddProductPage />} />
        <Route
          path="admin/edit-product/:product_id"
          element={<AddProductPage />}
        />
        <Route
          path="admin/development-timeline/:id"
          element={<DevelopmentTimelinePage />}
        />
        <Route path="admin/filing-plans/:id" element={<FilingPlansPage />} />
        <Route path="admin/sales-report/:id" element={<SalesReportPage />} />
        <Route
          path="admin/report/development-timeline"
          element={<PDTReportPage />}
        />
        <Route
          path="admin/report/filing-plans"
          element={<FilingPlansReportPage />}
        />
        <Route
          path="admin/report/sales-report"
          element={<ConsolidatedSalesReportPage />}
        />
        <Route path="admin/profile" element={<AdminProfilePage />} />
        <Route path="admin/settings" element={<AdminSettingsPage />} />
        <Route
          path="admin/partner-compliance"
          element={<PartnerCompliancePage />}
        />
        <Route
          path="admin/partner-compliance/:id"
          element={<PartnerCompliancePage />}
        />
        {/* Removed as per Client Requirement */}
        {/* <Route path="admin/mom" element={<MOMPage />} />
        <Route path="admin/mom/:id" element={<MOMPage />} /> */}
        <Route
          path="admin/compliance-template"
          element={<ComplianceTemplatePage />}
        />
        <Route
          path="admin/add-compliance-template"
          element={<AddComplianceTemplatePage />}
        />
        <Route
          path="admin/edit-compliance-template/:id"
          element={<AddComplianceTemplatePage />}
        />
        <Route
          path="admin/compliance-template/assign"
          element={<AssignComplianceTemplatePage />}
        />
        <Route path="admin/interactive-map" element={<InteractiveMapPage />} />
        <Route path="admin/data-management" element={<DataManagement />} />
        <Route
          path="admin/royalty-sales-approval"
          element={<PartnerRoyaltySalesApprovalPage />}
        />
        <Route
          path="admin/view-raised-request/:id"
          element={<ViewRaisedRequestPage />}
        />
        <Route
          path="partner/partner-invoice"
          element={<PartnerInvoicePage />}
        />
        <Route
          path="partner/view-invoice/:id"
          element={<ViewInvoiceInvoiceTrackingPage />}
        />
        <Route
          path="partner/view-tax-invoice/:id"
          element={<ViewTaxInvoiceTrackingPage />}
        />
        <Route
          path="partner/add-payment-proof/:id"
          element={<AddPaymentProofPage />}
        />
        <Route path="partner/dashboard" element={<PartnerDashboardPage />} />
        <Route path="partner/profile" element={<PartnerProfilePage />} />
        <Route
          path="partner/development-timeline"
          element={<DevelopmentTimelinePage />}
        />
        <Route path="partner/filing-plans" element={<FilingPlansPage />} />
        <Route path="partner/sales-report" element={<SalesReportPage />} />
        <Route
          path="partner/compliance-letter"
          element={<PartnerComplianceLetterPage />}
        />
        <Route path="partner/chats" element={<ChatsPage />} />
        <Route
          path="partner/royalty-sales-approvals"
          element={<PartnerRoyaltySalesApprovalPage />}
        />
        {/* New routes added here */}
        <Route
          path="partner/royalty-sales-approvals/raise-request"
          element={<RaiseApprovalRequestPage />}
        />
        <Route
          path="partner/royalty-sales-approvals/edit-request/:request_id"
          element={<RaiseApprovalRequestPage />}
        />
        {/* End of new routes */}
        <Route
          path="partner/royalty-sales-approvals/view/:id"
          element={<ViewRaisedRequestPage />}
        />
        <Route
          path="partner/partner-invoice"
          element={<PartnerInvoicePage />}
        />
        <Route
          path="partner/add-invoice/:id"
          element={<AddInvoiceDataPage />}
        />
        <Route path="partner/add-tax-data/:id" element={<AddTaxDataPage />} />
        <Route
          path="partner/view-invoice/:id"
          element={<ViewInvoiceInvoiceTrackingPage />}
        />
        <Route
          path="partner/partner-invoice/raise-request"
          element={<AddInvoiceDataPage />}
        />
        <Route
          path="partner/partner-tax-invoice/raise-request"
          element={<AddTaxDataPage />}
        />
        <Route
          path="partner/partner-invoice/edit-request/:tracking_id"
          element={<AddInvoiceDataPage />}
        />
        <Route
          path="partner/partner-invoice/add-payment-proof/edit-request/:tracking_id"
          element={<AddPaymentProofPage />}
        />
        <Route
          path="partner/partner-tax-invoice/edit-request/:tax_id"
          element={<AddTaxDataPage />}
        />
        <Route
          path="partner/partner-invoice/view/:tracking_id"
          element={<ViewInvoiceInvoiceTrackingPage />}
        />
        <Route
          path="partner/tax-invoice/view/:tax_id"
          element={<ViewTaxInvoiceTrackingPage />}
        />
        <Route
          path="partner/view-tax-invoice/:id"
          element={<ViewTaxInvoiceTrackingPage />}
        />
        <Route
          path="partner/add-payment-proof/:id"
          element={<AddPaymentProofPage />}
        />
        <Route
          path="admin/approval-requests"
          element={<ApprovalRequestsPage />}
        />
        <Route
          path="partner/approval-requests"
          element={<ApprovalRequestsPage />}
        />
        <Route
          path="legal/approval-requests"
          element={<ApprovalRequestsPage />}
        />
        <Route
          path="licensor/approval-requests"
          element={<ApprovalRequestsPage />}
        />
        <Route path="*" element={<NotFoundRedirect />} />
      </Routes>
    </div>
  );
};

export default App;